<template>
  <va-card>
    <va-card-title class="tile-header">
      <slot name="title">
        {{ props.title }}
      </slot>
      <div class="tile-actions">
        <slot name="actions" />
      </div>
    </va-card-title>
    <va-card-content>
      <table class="kv-table">
        <tr v-if="props.rows.length === 0">
          <td class="no-data" colspan="2">{{ noDataMessage }}</td>
        </tr>
        <tr
          v-for="(row, index) in props.rows"
          :key="`row-${i18nPrefix}-${index}}`"
        >
          <td>
            <label>{{ row.label }}</label>
          </td>
          <slot v-if="!editMode || !row.editable" :name="`${row.label}-value`">
            <td>
              {{ row.value || "/" }}
              <router-link v-if="row.link" :to="row.link">
                <va-button class="ml-2" flat icon="arrow_forward" />
              </router-link>
              <button-clipboard-copy
                v-if="row.copyable"
                :field="row.label"
                :value="row.value"
              />
            </td>
          </slot>
          <slot v-else :name="`${row.label}-edit-value`" />
        </tr>
      </table>
    </va-card-content>
  </va-card>
</template>

<script setup>
import ButtonClipboardCopy from "@/components/ButtonClipboardCopy.vue";

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  i18nPrefix: {
    type: String,
    required: true
  },
  // [{label, value, editable, copyable}]
  rows: {
    type: Array,
    required: true
  },
  editMode: {
    type: Boolean,
    default: false
  },
  noDataMessage: {
    type: String,
    default: "No Data to display"
  }
});
</script>

<style scoped>
.tile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.tile-actions {
  margin-left: auto;
}

.kv-table label:after {
  content: ":";
}

.kv-table td {
  padding: 0.5rem;
}

.kv-table label {
  font-size: 0.9em;
  font-weight: 700;
  color: var(--va-gray);
  text-transform: uppercase;
}
.no-data {
  padding: 1rem;
  text-align: center;
  font-weight: bold;
  color: #7a7979;
}

.actions-container {
  margin-left: auto;
  display: flex;
  gap: 0.5rem;
}
</style>
